import React from "react";
import { RiComputerFill } from "react-icons/ri";
import experienceData from "./Experience.json";

const Experience = () => {
  return (
    <div>
      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <RiComputerFill />
          </div>
          <h3 className="h3">Internship Experience</h3>
        </div>

        <ol className="timeline-list">
          {experienceData.map((exp, ind) => (
            <li className="timeline-item" key={ind}>
              <h4 className="h4 timeline-item-title experience-title">
                {exp.position} — {exp.company}
              </h4>

              <span>
                {exp.startYear} - {exp.endYear}
              </span>

              <div className="timeline-text experience-text">
                {exp.description.map((item, index) => (
                  <div className="experience-flex" key={index}>
                    <strong>{item.title}:</strong>{" "}
                    <span>{item.content}</span>
                  </div>
                ))}
              </div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
};

export default Experience;
